export enum SocketEvent {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',

  END_QUIZ_SESSION = 'END_QUIZ_SESSION',
  END_EXAM_SESSION = 'END_EXAM_SESSION',
}
